export default __webpack_public_path__ + "static/media/upload_icon.c36e9577.svg";